export default __webpack_public_path__ + "static/media/Timeline Dark.77328f99.svg";